<template>
    <div class="jgchart">
        <section class="mod mod2">
            <a class="link-more">
                <dl class="mod-top" @click="gogufs">
                    <dt>
                        {{ stockInform.stockName }}
                        <div :class="stockInform.rate | formateRedGreen">
                            <span>{{ stockInform.value | process }}</span
                            ><span
                                >{{
                                    stockInform.rate | formatePrefixData
                                }}%</span
                            >
                        </div>
                    </dt>
                    <dd>{{ stockInform.stockCode.substr(2) }}</dd>
                </dl>
            </a>
            <div class="chart-info flex" v-if="chgData.length">
                <div>
                    <strong>{{ jgName }}</strong>
                </div>
                <div>
                    持仓该股市值<strong>{{
                        chgData[0].holdamt | process
                    }}</strong>
                </div>
                <div>
                    增持该股市值<strong
                        :class="chgData[0].cbuyamt | formateClass"
                        >{{ chgData[0].cbuyamt | process }}</strong
                    >
                </div>
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit mod-tit2">北向资金增仓历史<i class=""></i></h2>
            <div class="nav2">
                <div class="nav2-wrap flex">
                    <span
                        v-for="(nav, i) in zcNavs"
                        :key="i"
                        :class="curzcNav == i ? 'cur' : ''"
                        @click="checkNavOne(nav, i)"
                        >{{ nav }}</span
                    >
                </div>
            </div>
            <div class="firstChartBox">
                <div class="chart chart-hold" id="line"></div>
                <div class="legend">
                    <div class="first">
                        <span class="last_dom"></span>
                        <span class="one_dom"></span>
                        <span>{{ zcNavs[curzcNav] }}</span>
                    </div>
                    <div class="last">
                        <span class="one_dom"></span>
                        <span>收盘价</span>
                    </div>
                </div>
            </div>
            <div class="table-scroll table-scroll-s">
                <div class="table-l fl">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>日期</th>
                        </tr>
                        <tr v-for="(item, index) in zcList" :key="index">
                            <td>近{{ item.days }}日</td>
                        </tr>
                    </table>
                </div>
                <div class="table-r">
                    <div class="table-r-wrap table-r-wrap3">
                        <table width="100%" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>增持市值(元)</th>
                                <th>增持股数(股)</th>
                                <th>增持占比(%)</th>
                                <th>阶段涨幅(%)</th>
                            </tr>
                            <tr v-for="(item, index) in zcList" :key="index">
                                <td :class="item.cbuyamt | formateClass">
                                    {{ item.cbuyamt | process }}
                                </td>
                                <td :class="item.holdchg | formateClass">
                                    {{ item.holdchg | process }}
                                </td>
                                <td :class="item.bdzb | formateClass">
                                    {{ item.bdzb | gains("%", "count") }}
                                </td>
                                <td :class="item.pchg | formateClass">
                                    {{ item.pchg | gains("%", "notCount") }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <section class="mod">
            <h2 class="mod-tit mod-tit2">北向资金持仓历史</h2>
            <div class="nav2">
                <div class="nav2-wrap flex">
                    <span
                        v-for="(nav, i) in ccNavs"
                        :key="i"
                        :class="curccNav == i ? 'cur' : ''"
                        @click="checkNavTwo(nav, i)"
                        >{{ nav }}</span
                    >
                </div>
            </div>
            <div class="chart chart-hold" id="line2"></div>
            <div class="table-scroll table-scroll-m">
                <div class="table-l fl">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>日期</th>
                        </tr>
                        <tr v-for="(item, index) in chgData" :key="index">
                            <td>{{ item.tradedate | dataStr }}</td>
                        </tr>
                    </table>
                </div>
                <div class="table-r">
                    <div class="table-r-wrap table-r-wrap7">
                        <table width="100%" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>持仓市值(元)</th>
                                <th>持仓股数(股)</th>
                                <th>持仓占流通股比(%)</th>
                                <th>收盘价(元)</th>
                                <th>涨幅(%)</th>
                            </tr>
                            <tr v-for="(item, index) in chgData" :key="index">
                                <td>{{ item.holdamt | process }}</td>
                                <td>{{ item.holdvol | process }}</td>
                                <td :class="item.cgzb | formateClass">
                                    {{ item.cgzb | gains("%", "notCount") }}
                                </td>
                                <td :class="item.pchg | formateClass">
                                    {{ item.tclose | process(2, false) }}
                                </td>
                                <td :class="item.pchg | formateClass">
                                    {{ item.pchg | gains("%", "notCount") }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { stockinfo } from "@/api/index.js";
import { getStkHolderchg, getStkHolderstat } from "@/api/xqDetail.js";
import { getUrlQuery } from "@/utils/handleUrl.js";
import { share } from "@/lib/dzh";
import wxshare from "@/assets/js/wxshare";
export default {
    name: "jgChartDetail",
    components: {},
    data() {
        return {
            curzcNav: 0,
            zcNavs: ["增持市值", "增持股数", "增持占比"],
            zcList: [],
            curccNav: 0,
            ccNavs: ["持仓市值", "持股数", "占流通股比"],
            stockCode: "",
            code: "",
            stockInform: {
                stockName: "",
                stockCode: "",
                value: "",
                rate: "",
            },
            token: "", //云平台token
            userToken: "", //用户token
            chgData: [], // 个股-港资机构-持股变化历史图
            jgName: "",
            lineDom: null,
            lineDomTwo: null,
        };
    },
    filters: {
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return "fr";
            if (v > 0) return "fr ft-red";
            if (v < 0) return "fr ft-green";
        },
        formateClass: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        // 处理金额
        process: function (value, fixed = 2, isZero) {
            if (value) {
                if (!isNaN(value)) {
                    value = Number(value);
                    let len = parseInt(Math.abs(value), 10).toString().length;
                    value =
                        (len > 12 && value / 1000000000000) ||
                        (len > 8 && value / 100000000) ||
                        (len > 4 && value / 10000) ||
                        value;
                    if (
                        !isZero ||
                        (!/^[-+]?\d*$/.test(value.toString()) &&
                            value.toString().split(".")[1].length > fixed)
                    ) {
                        value = value.toFixed(fixed);
                    }
                    value =
                        (len > 12 && value + "万亿") ||
                        (len > 8 && value + "亿") ||
                        (len > 4 && value + "万") ||
                        value;
                }
            } else if (value === 0) {
                value = "0.00";
            } else {
                value = "--";
            }
            return value;
        },
        // 处理百分比
        gains: function (val, str, type) {
            let valNum;
            if (type === "count") {
                valNum = val * 100;
            } else {
                valNum = val;
            }
            if (valNum || valNum === 0) {
                var multiple = Math.pow(10, 2);
                return (
                    (Math.round(valNum * multiple) / multiple).toFixed(2) + str
                );
            } else {
                return "--";
            }
        },
        // 时间处理
        dataStr: function (val) {
            if (val) {
                return (
                    val.substr(0, 4) +
                    "-" +
                    val.substr(4, 2) +
                    "-" +
                    val.substr(6, 2)
                );
            }
        },
    },
    created() {
        this.stockCode = this.$route.query.stockCode;
        this.code = this.$route.query.code;
        this.jgName = this.$route.query.name;
        this.userToken = getUrlQuery("token");
        this.version = getUrlQuery("version");
        wxshare.do(
            this.$route.fullPath,
            "http://static.yundzh.com/logo.png",
            "沪深港通"
        );
    },
    mounted: function () {
        this.getYunToken();
        this.getHolderchg();
        this.getHolderstat();
        document.title = "沪深港通";
        share("沪深港通", this.$route.fullPath);
        if (history.scrollRestoration) {
            history.scrollRestoration = "manual";
        }
    },
    methods: {
        // 获取云平台token
        getYunToken: function () {
            let that = this;
            stockinfo().then((res) => {
                that.token = res.data.data.token;
                that.$nextTick(() => {
                    const data = res.data.data;
                    that.getStocksZf(data.url, data.token);
                });
            });
        },
        //获取当前个股加个以及涨幅
        getStocksZf: function (url, token) {
            let that = this;
            if (!this.websocket) {
                this.websocket = new WebSocket(`${url}/ws?token=${token}`);
                this.websocket.onopen = () => {
                    this.websocketSend();
                };
            } else {
                this.websocket.send(`/cancel?qid=1`);
                this.websocketSend();
            }
            this.websocket.onmessage = (evt) => {
                let fr = new FileReader();
                fr.readAsText(evt.data);
                fr.onload = () => {
                    let result = JSON.parse(fr.result);
                    let dynaList = result.Data.RepDataStkData;
                    if (dynaList) {
                        that.stockInform = {
                            stockName: dynaList[0].ZhongWenJianCheng,
                            stockCode: dynaList[0].Obj,
                            value: dynaList[0].ZuiXinJia,
                            rate: dynaList[0].ZhangFu,
                        };
                    }
                };
            };
            this.websocket.onclose = () => {
                this.websocket.close();
                this.websocket = null;
                this.getYunToken();
            };
        },
        websocketSend() {
            this.websocket.send(
                `/stkdata?obj=${this.stockCode}&field=ZhongWenJianCheng,ZuiXinJia,ZhangFu&qid=1&sub=1`
            );
        },
        // 请求持股变化历史图
        getHolderchg: function () {
            let that = this;
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let type;
            if (isiOS) {
                type = "ios";
            } else if (isAndroid) {
                type = "android";
            }
            let obj = {
                httpdzh: that.version ? "dzh-" + type + "-" + that.version : "",
                stock: that.stockCode,
                token: that.userToken,
                qid: +new Date(),
                particode: that.code,
            };
            getStkHolderchg(obj).then((res) => {
                if (res.data.err === 0) {
                    that.chgData = res.data.data;
                    that.$nextTick(() => {
                        that.disposeData("holdamt", "line2", "持仓市值");
                        that.disposeData("cbuyamt", "line", "增持市值");
                    });
                }
            });
        },
        // 个股-港资机构-增仓阶段统计
        getHolderstat: function () {
            let that = this;
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let type;
            if (isiOS) {
                type = "ios";
            } else if (isAndroid) {
                type = "android";
            }
            let obj = {
                httpdzh: that.version ? "dzh-" + type + "-" + that.version : "",
                stock: that.stockCode,
                token: that.userToken,
                qid: +new Date(),
                particode: that.code,
            };
            getStkHolderstat(obj).then((res) => {
                if (res.data.err === 0) {
                    that.zcList = res.data.data;
                }
            });
        },
        // 点击切换navOne
        checkNavOne: function (nav, i) {
            this.curzcNav = i;
            this.lineDom.dispose();
            this.lineDom = "";
            let type;
            // 增持市值','增持股数','增持占比'
            if (nav === "增持市值") {
                type = "cbuyamt";
            } else if (nav === "增持股数") {
                type = "holdchg";
            } else {
                type = "bdzb";
            }
            this.disposeData(type, "line", nav);
        },
        checkNavTwo: function (nav, i) {
            this.curccNav = i;
            this.lineDomTwo.dispose();
            this.lineDomTwo = "";
            let type;
            // 持仓市值','持股数','占流通股比'
            if (nav === "持仓市值") {
                type = "holdamt";
            } else if (nav === "持股数") {
                type = "holdvol";
            } else {
                type = "cgzb";
            }
            this.disposeData(type, "line2", nav);
        },
        //处理表格数据
        disposeData: function (type, id, name) {
            let that = this;
            let { chgData } = that;
            let arr = JSON.parse(JSON.stringify(chgData)).reverse();
            let dateArr = arr.map((item) => {
                return (
                    item.tradedate.substr(0, 4) +
                    "-" +
                    item.tradedate.substr(4, 2) +
                    "-" +
                    item.tradedate.substr(6, 2)
                );
            });
            if (id === "line2") {
                let dataArr1 = arr.map((item) => {
                    return item[type];
                });
                let tcloseArr1 = arr.map((item) => {
                    return {
                        value: item.tclose,
                        cgNum: item.holdvol,
                        cgzb: item.cgzb,
                    };
                });
                that.drawLine(dateArr, tcloseArr1, dataArr1, name);
            } else if (id === "line") {
                let dataArr = arr.map((item) => {
                    if (type === "bdzb") {
                        return that.gainsNum(item[type], "", "");
                    } else {
                        return item[type];
                    }
                });
                let tcloseArr = arr.map((item) => {
                    return {
                        value: item.tclose,
                        zb: item.bdzb,
                        zcgs: item.holdchg,
                    };
                });
                that.drawLinew(dateArr, tcloseArr, dataArr, name);
            }
        },
        // 绘制双折现图
        drawLine: function (dateArr, tcloseArr, dataArr, name) {
            let that = this;
            if (!that.lineDomTwo) {
                var chartDom = document.getElementById("line2");
                that.lineDomTwo = this.$echarts.init(chartDom);
            }
            var option;
            option = {
                color: ["#F06F6F", "#7EB2F3"],
                tooltip: {
                    trigger: "axis",
                    confine: true,
                    formatter: function (params) {
                        let str;
                        if (name === "占流通股比") {
                            str = `<div class="tooltip">
            <div class="date">${params[0].axisValue}</div>
            <div class="item"><span style="width:10px;height:10px;background-color:${
                params[0].color
            };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>${name}：</span><em>${
                                params[0].value
                            }%</em></div>
						<div class="item"><span style="width:10px;height:10px;background-color:${
                            params[1].color
                        };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>收盘价：</span><em>${that.process(
                                params[1].value
                            )}</em></div>
            </div>`;
                        } else {
                            str = `<div class="tooltip">
            <div class="date">${params[0].axisValue}</div>
            <div class="item"><span style="width:10px;height:10px;background-color:${
                params[0].color
            };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>${name}：</span><em>${that.process(
                                params[0].value
                            )}</em></div>
						<div class="item"><span style="width:10px;height:10px;background-color:${
                            params[1].color
                        };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>收盘价：</span><em>${that.process(
                                params[1].value
                            )}</em></div>
            </div>`;
                        }
                        return str;
                    },
                },
                legend: {
                    type: "plain",
                    bottom: 0,
                    left: 0,
                    icon: "rect",
                    itemWidth: 10,
                    itemHeight: 2,
                    itemGap: 30,
                    selectedMode: false,
                },
                grid: {
                    left: 10,
                    right: 10,
                    bottom: 20,
                    top: 30,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                    data: dateArr,
                    axisLabel: {
                        color: "#999",
                        show: true,
                        interval: 10000,
                        showMinLabel: true,
                        showMaxLabel: true,
                        formatter: function (value) {
                            //文本格式化
                            if (value === dateArr[0]) {
                                return "{right|" + value + "}";
                            } else if (value === dateArr[dateArr.length - 1]) {
                                return "{left|" + value + "}";
                            } else {
                                return "{center|" + value + "}";
                            }
                        },
                        rich: {
                            right: {
                                width: 50,
                                fontSize: 10,
                                align: "left",
                                padding: [0, 0, 0, 50],
                            },
                            left: {
                                width: 50,
                                fontSize: 10,
                                align: "left",
                                padding: [0, 50, 0, 0],
                            },
                            center: {
                                fontSize: 10,
                                align: "left",
                            },
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#C8C8C8",
                        },
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        nameTextStyle: {
                            color: "#999",
                            align: "left",
                        },
                        position: "right",
                        splitNumber: 4,
                        alignTicks: true,
                        scale: true,
                        gridIndex: 0,
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                if (name === "占流通股比") {
                                    return that.gainsNum(value, "%", "count");
                                } else {
                                    return that.process(value);
                                }
                            },
                        },
                    },
                    {
                        type: "value",
                        alignTicks: true,
                        scale: true,
                        position: "left",
                        splitNumber: 4,
                        yAxisIndex: 1,
                        splitLine: { show: false },
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                return that.process(value);
                            },
                        },
                        min: function (value) {
                            return value.min - 10;
                        },
                    },
                ],
                series: [
                    {
                        name: name,
                        type: "line",
                        stack: "Total",
                        data: dataArr,
                    },
                    {
                        name: "收盘价",
                        type: "line",
                        yAxisIndex: 1,
                        data: tcloseArr,
                    },
                ],
            };
            that.lineDomTwo.setOption(option);
            window.addEventListener("resize", function () {
                that.lineDomTwo.resize();
            });
        },
        // 绘制柱状、折现结合图表
        drawLinew: function (dateArr, tcloseArr, dataArr, name) {
            let that = this;
            if (!that.lineDom) {
                var chartDom = document.getElementById("line");
                that.lineDom = this.$echarts.init(chartDom);
            }
            var option;
            option = {
                color: ["#F06F6F", "#7EB2F3"],
                tooltip: {
                    trigger: "axis",
                    confine: true,
                    formatter: function (params) {
                        let str;
                        if (name === "增持占比") {
                            str = `<div class="tooltip">
            <div class="date">${params[0].axisValue}</div>
            <div class="item"><span style="width:10px;height:10px;background-color:${
                params[0].color
            };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>${name}：</span><em>${
                                params[0].value
                            }%</em></div>
						<div class="item"><span style="width:10px;height:10px;background-color:${
                            params[1].color
                        };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>收盘价：</span><em>${that.process(
                                params[1].value
                            )}</em></div>
            </div>`;
                        } else {
                            str = `<div class="tooltip">
            <div class="date">${params[0].axisValue}</div>
            <div class="item"><span style="width:10px;height:10px;background-color:${
                params[0].color
            };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>${name}：</span><em>${that.process(
                                params[0].value
                            )}</em></div>
						<div class="item"><span style="width:10px;height:10px;background-color:${
                            params[1].color
                        };display:inline-block;border-radius:50%;margin-right:6px;"></span><span>收盘价：</span><em>${that.process(
                                params[1].value
                            )}</em></div>
            </div>`;
                        }
                        return str;
                    },
                },
                grid: {
                    left: 10,
                    right: 10,
                    bottom: 20,
                    top: 30,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                    data: dateArr,
                    axisLabel: {
                        color: "#999",
                        show: true,
                        interval: 10000,
                        showMinLabel: true,
                        showMaxLabel: true,
                        formatter: function (value) {
                            //文本格式化
                            if (value === dateArr[0]) {
                                return "{right|" + value + "}";
                            } else if (value === dateArr[dateArr.length - 1]) {
                                return "{left|" + value + "}";
                            } else {
                                return "{center|" + value + "}";
                            }
                        },
                        rich: {
                            right: {
                                width: 50,
                                fontSize: 10,
                                align: "left",
                                padding: [0, 0, 0, 50],
                            },
                            left: {
                                width: 50,
                                fontSize: 10,
                                align: "left",
                                padding: [0, 50, 0, 0],
                            },
                            center: {
                                fontSize: 10,
                                align: "left",
                            },
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#C8C8C8",
                        },
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        position: "right",
                        nameTextStyle: {
                            color: "#999",
                            align: "left",
                        },
                        splitNumber: 3,
                        alignTicks: true,
                        scale: true,
                        gridIndex: 0,
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                if (name === "增持占比") {
                                    return that.gainsNum(value, "%", "count");
                                } else {
                                    return that.process(value);
                                }
                            },
                        },
                    },
                    {
                        type: "value",
                        alignTicks: true,
                        scale: true,
                        splitNumber: 3,
                        min: function (val) {
                            return val.min - 10;
                        },
                        max: function (val) {
                            return val.max + 10;
                        },
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                return that.process(value);
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: name,
                        type: "bar",
                        stack: "total",
                        data: dataArr,
                        itemStyle: {
                            color: function (params) {
                                return params.value >= 0
                                    ? "#e30000"
                                    : "#4ca92a";
                            },
                        },
                    },
                    {
                        name: "收盘价",
                        type: "line",
                        yAxisIndex: 1,
                        symbol: "none",
                        data: tcloseArr,
                    },
                ],
            };
            that.lineDom.setOption(option);
            window.addEventListener("resize", function () {
                that.lineDom.resize();
            });
        },
        // 处理金额
        process: function (value, fixed = 2, isZero) {
            if (value) {
                if (!isNaN(value)) {
                    value = Number(value);
                    let len = parseInt(Math.abs(value), 10).toString().length;
                    value =
                        (len > 12 && value / 1000000000000) ||
                        (len > 8 && value / 100000000) ||
                        (len > 4 && value / 10000) ||
                        value;
                    if (
                        !isZero ||
                        (!/^[-+]?\d*$/.test(value.toString()) &&
                            value.toString().split(".")[1].length > fixed)
                    ) {
                        value = value.toFixed(fixed);
                    }
                    value =
                        (len > 12 && value + "万亿") ||
                        (len > 8 && value + "亿") ||
                        (len > 4 && value + "万") ||
                        value;
                }
            } else if (value === 0) {
                value = "0.00";
            } else {
                value = "--";
            }
            return value;
        },
        // 计算处理百分比
        gainsNum: function (val, str, type) {
            if (val || val === 0) {
                let valNum;
                if (type === "count") {
                    valNum = val;
                } else {
                    valNum = val * 100;
                }
                var multiple = Math.pow(10, 2);
                return (
                    (Math.round(valNum * multiple) / multiple).toFixed(2) + str
                );
            } else {
                return "--";
            }
        },
        // 跳转到个股分时
        gogufs: function () {
            window.location.href = `dzh_browser_url&goto=0&type=2970&code=${this.stockCode}&kind=1`;
        },
    },
};
</script>
